import { useEffect, useState } from 'react';
import axios from 'axios';
import { useAuth } from '../contexts/AuthContext';

// True when the signed-in staff member trains or has children on their
// account, so the menu can offer My Progress alongside Skill Tracking.
export default function useHasMyGymnasts() {
  const { user, isStaff } = useAuth();
  const [has, setHas] = useState(false);
  useEffect(() => {
    if (!user || !isStaff) { setHas(false); return undefined; }
    let cancelled = false;
    axios.get('/api/gymnasts/my-children')
      .then(res => { if (!cancelled) setHas(res.data.length > 0); })
      .catch(() => { if (!cancelled) setHas(false); });
    return () => { cancelled = true; };
  }, [user, isStaff]);
  return has;
}
